export default {
  id: "preparacion-bautismo",
  type: "short_study",
  durationDays: 3,
  titleKey: "programs.preparacionBautismo.title",
  descriptionKey: "programs.preparacionBautismo.desc",
  modules: [
    {
      id: "mod-1",
      titleKey: "programs.preparacionBautismo.mod1.title",
      lessons: [
        // Día 1
        {
          id: "les-1",
          titleKey: "programs.preparacionBautismo.mod1.les1.title",
          contentBlocks: [
            {
              type: "verse",
              reference: "Matthew 28:18-20",
              referenceKey: "programs.preparacionBautismo.mod1.les1.ref1",
              textKey: "programs.preparacionBautismo.mod1.les1.verse1",
            },
            {
              type: "verse",
              reference: "Mark 16:16",
              referenceKey: "programs.preparacionBautismo.mod1.les1.ref2",
              textKey: "programs.preparacionBautismo.mod1.les1.verse2",
            },
            {
              type: "verse",
              reference: "Acts 2:37-41",
              referenceKey: "programs.preparacionBautismo.mod1.les1.ref3",
              textKey: "programs.preparacionBautismo.mod1.les1.verse3",
            },
            {
              type: "verse",
              reference: "Romans 10:9-10",
              referenceKey: "programs.preparacionBautismo.mod1.les1.ref4",
              textKey: "programs.preparacionBautismo.mod1.les1.verse4",
            },
            {
              type: "text",
              textKey: "programs.preparacionBautismo.mod1.les1.consider",
            },
          ],
          questions: [
            { id: "les1-sum1", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.sum1", afterBlock: 0 },
            { id: "les1-sum2", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.sum2", afterBlock: 1 },
            { id: "les1-sum3", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.sum3", afterBlock: 2 },
            { id: "les1-sum4", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.sum4", afterBlock: 3 },
            { id: "les1-q1", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.q1" },
            { id: "les1-q2", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.q2" },
            { id: "les1-q3", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.q3" },
            { id: "les1-q4", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les1.q4" },
            { id: "les1-app", type: "application", promptKey: "programs.preparacionBautismo.mod1.les1.app" },
          ],
          prayerKey: "programs.preparacionBautismo.mod1.les1.prayer",
        },

        // Día 2
        {
          id: "les-2",
          titleKey: "programs.preparacionBautismo.mod1.les2.title",
          contentBlocks: [
            {
              type: "verse",
              reference: "Romans 6:3-5",
              referenceKey: "programs.preparacionBautismo.mod1.les2.ref1",
              textKey: "programs.preparacionBautismo.mod1.les2.verse1",
            },
            {
              type: "verse",
              reference: "Colossians 2:12",
              referenceKey: "programs.preparacionBautismo.mod1.les2.ref2",
              textKey: "programs.preparacionBautismo.mod1.les2.verse2",
            },
            {
              type: "verse",
              reference: "2 Corinthians 5:17",
              referenceKey: "programs.preparacionBautismo.mod1.les2.ref3",
              textKey: "programs.preparacionBautismo.mod1.les2.verse3",
            },
            {
              type: "verse",
              reference: "Galatians 2:20",
              referenceKey: "programs.preparacionBautismo.mod1.les2.ref4",
              textKey: "programs.preparacionBautismo.mod1.les2.verse4",
            },
            {
              type: "text",
              textKey: "programs.preparacionBautismo.mod1.les2.consider",
            },
          ],
          questions: [
            { id: "les2-sum1", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.sum1", afterBlock: 0 },
            { id: "les2-sum2", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.sum2", afterBlock: 1 },
            { id: "les2-sum3", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.sum3", afterBlock: 2 },
            { id: "les2-sum4", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.sum4", afterBlock: 3 },
            { id: "les2-q1", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.q1" },
            { id: "les2-q2", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.q2" },
            { id: "les2-q3", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.q3" },
            { id: "les2-q4", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les2.q4" },
            { id: "les2-app", type: "application", promptKey: "programs.preparacionBautismo.mod1.les2.app" },
          ],
          prayerKey: "programs.preparacionBautismo.mod1.les2.prayer",
        },

        // Día 3
        {
          id: "les-3",
          titleKey: "programs.preparacionBautismo.mod1.les3.title",
          contentBlocks: [
            {
              type: "verse",
              reference: "Acts 2:41-47",
              referenceKey: "programs.preparacionBautismo.mod1.les3.ref1",
              textKey: "programs.preparacionBautismo.mod1.les3.verse1",
            },
            {
              type: "verse",
              reference: "Romans 12:1-2",
              referenceKey: "programs.preparacionBautismo.mod1.les3.ref2",
              textKey: "programs.preparacionBautismo.mod1.les3.verse2",
            },
            {
              type: "verse",
              reference: "Luke 9:23",
              referenceKey: "programs.preparacionBautismo.mod1.les3.ref3",
              textKey: "programs.preparacionBautismo.mod1.les3.verse3",
            },
            {
              type: "verse",
              reference: "Hebrews 10:24-25",
              referenceKey: "programs.preparacionBautismo.mod1.les3.ref4",
              textKey: "programs.preparacionBautismo.mod1.les3.verse4",
            },
            {
              type: "verse",
              reference: "1 Corinthians 11:23-26",
              referenceKey: "programs.preparacionBautismo.mod1.les3.ref5",
              textKey: "programs.preparacionBautismo.mod1.les3.verse5",
            },
            {
              type: "text",
              textKey: "programs.preparacionBautismo.mod1.les3.consider",
            },
          ],
          questions: [
            { id: "les3-sum1", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.sum1", afterBlock: 0 },
            { id: "les3-sum2", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.sum2", afterBlock: 1 },
            { id: "les3-sum3", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.sum3", afterBlock: 2 },
            { id: "les3-sum4", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.sum4", afterBlock: 3 },
            { id: "les3-sum5", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.sum5", afterBlock: 4 },
            { id: "les3-q1", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.q1" },
            { id: "les3-q2", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.q2" },
            { id: "les3-q3", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.q3" },
            { id: "les3-q4", type: "reflection", promptKey: "programs.preparacionBautismo.mod1.les3.q4" },
            { id: "les3-app", type: "application", promptKey: "programs.preparacionBautismo.mod1.les3.app" },
          ],
          prayerKey: "programs.preparacionBautismo.mod1.les3.prayer",
        },
      ],
    },
  ],
};
